import {
  InvoiceRow,
  PayableRow,
  PayeeRow,
  PayerRow
} from "@wingspanhq/wingspan-api-sdk";

export const selectorSearchRowName = (
  row: PayerRow | PayeeRow | InvoiceRow | PayableRow
) => {
  if (row.profile?.resolvedName) {
    return row.profile.resolvedName;
  }

  if (row.profile?.displayName) {
    return row.profile.displayName;
  }

  const individualName = [row.profile?.firstName, row.profile?.lastName]
    .filter(Boolean)
    .join(" ");

  if (individualName) {
    return individualName;
  }

  if (row.profile?.companyName) {
    return row.profile.companyName;
  }

  if (row.profile?.doingBusinessAs) {
    return row.profile.doingBusinessAs;
  }

  if (row.email) {
    return row.email;
  }

  return "";
};
